import toast from "react-hot-toast";
import { supabase } from "../../api/supabase/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";

//for react router to prevent private routes from displaying if user isn't logged in
import { useEffect, useState } from "react";
import { Session } from "@supabase/supabase-js";

export default function AuthenticationWall({
  loginPageRoute,
}: {
  loginPageRoute: string;
}) {
  const location = useLocation();
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    const main = async () => {
      const currentSession = await supabase.auth.getSession();
      setSession(currentSession.data.session);
    };
    main();
  }, []);

  if (session === null) {
    return <div>Loading...</div>;
  }

  const isLoggedInWithEmailConfirmed =
    session?.user?.email_confirmed_at !== undefined;

  const warningMessage = `Authencation Wall has been invoked at ${location.pathname}! Navigating to ${loginPageRoute}`;
  if (!isLoggedInWithEmailConfirmed) {
    toast.error(warningMessage);
    console.warn(warningMessage);
  }

  return isLoggedInWithEmailConfirmed ? (
    <Outlet />
  ) : (
    <Navigate to={loginPageRoute} />
  );
}
